export function customerAvailabilityCopy(
  quantityLimitEnabled: boolean,
  availableQuantity: number,
  lowAvailabilityThreshold: number,
  freshCopy = 'Made fresh to order',
): string {
  if (!quantityLimitEnabled || availableQuantity > lowAvailabilityThreshold) {
    return freshCopy
  }
  return availableQuantity <= 0 ? 'Sold out' : 'Limited availability'
}
